import script from "./XCalendarClean.vue?vue&type=script&lang=ts&setup=true"
export * from "./XCalendarClean.vue?vue&type=script&lang=ts&setup=true"

import "./XCalendarClean.vue?vue&type=style&index=0&id=30a72319&lang=css&scoped=true"

import exportComponent from "D:\\x1\\vue3-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-30a72319"]])

export default __exports__